/**
 * Return an imgproxy url to an image of requested size.
 *
 * @param {String}   imagePath    Path to the image. The absolute path from the blob storage root.
 * @param {Number}   width        Width of the image in pixels..
 * @param {Number}   height       Height of the image in pixels.
 * @param {String}   resizeOption 'fill' or 'fit'.
 *
 * See https://imgproxy.net/#demo for how resizeOption 'fill' differs from 'fit'.
 * Fit will add empty space around the picture without cropping
 * Fill will crop the image to given with and height without empty space
 */
export function imagePath(imagePath: string, width: number, height: number, resizeOption: 'fill' | 'fit' = 'fill') {
  if (typeof width !== 'number' || typeof height !== 'number') {
    return `${import.meta.env.VITE_BLOB_URL}/${imagePath}`;
  }

  return `${import.meta.env.VITE_IMG_PROXY_URL}/resize:${resizeOption}:${width}:${height}:1/plain/abs://${imagePath}`;
}
